import ROUTES from './routes';

export { ROUTES };
